import React from 'react';
import BaseComponent from './BaseContainer';
import { graphql, compose, withApollo } from 'react-apollo';
import { Redirect } from 'react-router';
import OfferForm from '../components/form/Offer';
import getOffer from '../apollo/graphql/offer/get';
import getOffers from '../apollo/graphql/offer/getOffers';
import getShops from '../apollo/graphql/shop/getShops';
import getPageBuilders from '../apollo/graphql/page-builder/getAll';
import createOffer from '../apollo/graphql/offer/create';
import deleteOffer from '../apollo/graphql/offer/delete';
import updateOffer from '../apollo/graphql/offer/update';
import {
  convertGraphQlToObject,
  convertObjetToGraphQlVariables,
} from '../helpers/contentWithI18n';
import { languages } from '../constants';
import { createTranslationsObject } from '../helpers/translation';

class OfferContainer extends BaseComponent {
  constructor(props) {
    super(props);

    const isNew =
      props.match.params.objId === 'new' ||
      props.match.params.objId === undefined;

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        isNew: isNew,
        deletion: { confirm: false },
      },
      redirect: false,
      obj: {
        translations: createTranslationsObject({
          title: '',
          offer_date: '',
          description: '',
          cta_label: '',
          cta_url: '',
        }),
      },
      languages: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    if (!this.state.status.isNew) {
      this.props.client
        .query({
          query: getOffer,
          variables: { id: this.props.match.params.objId },
        })
        .then(({ data }) => {
          if (getOffer.error) {
            this.setState({
              status: {
                ...this.state.status,
                error: true,
                message: getOffer.error.message,
              },
            });
          }

          const newObject = {
            ...this.state.obj,
            ...convertGraphQlToObject(data.getOffer),
          };
          this.setState({
            ...this.state,
            status: {
              ...this.state.status,
              loading: false,
            },
            obj: {
              ...this.state.obj,
              ...newObject,
              translations: {
                ...this.state.obj.translations,
                ...newObject.translations,
              },
            },
          });
        });
    } else {
      this.setState({
        ...this.state,
        status: {
          ...this.state.status,
          loading: false,
        },
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    let newState = {
      status: { ...this.state.status },
    };
    newState.status.loading = false;
    this.setState(newState);
  }

  handleChange(Offer, data, type) {
    let newState = {
      status: {
        ...this.state.status,
      },
      obj: {
        ...this.state.obj,
      },
    };
    let dataIsLanguage = false;
    for (let att of languages) {
      if (att.code === data) {
        dataIsLanguage = true;
      }
    }
    if (dataIsLanguage) {
      //translations data
      if (Offer.target.maxLength !== -1) {
        if (Offer.target.value.length <= Offer.target.maxLength) {
          newState.obj.translations[data][Offer.target.id] = Offer.target.value;
        }
      } else {
        let value = Offer.target.value;
        if (Offer.target.id === 'order' && Offer.target.value === '') {
          value = -1;
        }
        newState.obj.translations[data][Offer.target.id] = value;
      }
    } else if (type === 'dropdown') {
      //dropdown
      newState.obj[data.id] = data.value;
    } else if (Offer.target.files && Offer.target.files.length > 0) {
      //files
      newState.obj[Offer.target.id] = Offer.target.files[0];
    } else {
      //simple data

      newState.obj[Offer.target.id] = Offer.target.value;
    }
    this.setState(newState);
  }

  handleSubmit(Offer) {
    Offer.preventDefault();
    window.scrollTo(0, 0);
    this.setState({
      status: {
        ...this.state.status,
        loading: true,
        errors: [],
      },
    });
    const obj = convertObjetToGraphQlVariables(this.state.obj);

    if (!obj.shop_id && !obj.page_builder_id) {
      this.setState({
        status: {
          ...this.state.status,
          loading: false,
          errors: [{ message: 'Les champs enseigne OU page est obligatoire' }],
        },
      });
    } else {
      if (this.state.status.isNew) {
        let newObj = {
          input: {
            ...obj,
          },
        };
        if (obj.shop) {
          newObj.input.shop_id = obj.shop_id;
          delete newObj.shop_id;
        }
        if (obj.pageBuilder) {
          newObj.input.page_builder_id = obj.page_builder_id;
          delete newObj.page_builder_id;
        }

        this.props
          .createOffer({
            variables: {
              ...newObj,
            },
          })
          .then(({ data, errors }) => {
            if (errors) {
              this.setState({
                status: {
                  ...this.state.status,
                  loading: false,
                  errors: errors,
                },
              });
            } else {
              this.setState({
                status: {
                  ...this.state.status,
                  loading: false,
                  message: `Création effectuée le ${new Date(
                    Date.now(),
                  ).toLocaleString()}`,
                  isNew: false,
                },
                obj: data.createOffer,
                redirect: true,
              });
            }
          });
      } else {
        // update object
        let newObj = {
          id: obj.id,
          input: {
            ...obj,
          },
        };
        if (obj.shop) {
          newObj.input.shop_id = obj.shop.id;
          delete newObj.input.shop;
        }
        if (obj.pageBuilder) {
          newObj.input.page_builder_id = obj.pageBuilder.id;
          delete newObj.input.pageBuilder;
        }
        delete newObj.input.created_at;
        delete newObj.input.updated_at;
        this.props
          .updateOffer({
            variables: {
              ...newObj,
            },
          })
          .then(({ data, errors }) => {
            if (errors) {
              this.setState({
                status: {
                  ...this.state.status,
                  loading: false,
                  errors: errors,
                },
              });
            } else {
              this.setState({
                obj: data.updateOffer,
                redirect: true,
              });
            }
          });
      }
    }
  }

  handleDelete(Offer, data) {
    Offer.preventDefault();
    let newState = {
      status: {
        ...this.state.status,
        deletion: {},
      },
    };
    switch (data.confirm) {
      case true:
        newState.status.deletion.confirm = true;
        break;
      case null:
        newState.status.deletion.confirm = false;
        break;
      case false:
        newState.status.deletion.confirm = false;
        this.props
          .deleteOffer({ variables: { id: this.state.obj.id } })
          .then(this.props.history.push('/offers'))
          .catch((error) => {
            this.setState({
              status: {
                ...this.state.status,
                loading: false,
                message: error.message,
                error: true,
              },
            });
          });
        break;
      default:
        break;
    }
    this.setState(newState);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/offers" />;
    }

    return (
      <OfferForm
        obj={this.state.obj}
        status={this.state.status}
        shops={this.props.shops}
        pageBuilders={this.props.pageBuilders}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
        onDelete={this.handleDelete}
      />
    );
  }
}

const OfferContainerEnhanced = compose(
  graphql(getShops, { name: 'shops' }),
  graphql(getPageBuilders, { name: 'pageBuilders' }),
  graphql(updateOffer, { name: 'updateOffer' }),
  graphql(createOffer, { name: 'createOffer' }),
  graphql(deleteOffer, {
    name: 'deleteOffer',
    options: {
      update: (proxy, { data }) => {
        const Offers = proxy.readQuery({ query: getOffers });
        Offers.getOffers = Offers.getOffers.filter(
          (obj) => obj.id !== data.deleteOffer.id,
        );
        proxy.writeQuery({ query: getOffers, data: Offers });
      },
    },
  }),
)(OfferContainer);

export default withApollo(OfferContainerEnhanced);



// WEBPACK FOOTER //
// ./src/containers/OfferContainer.js